// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDChKu3IzWs8MpduRJ1Fg8flSHi-KJCuP0",
  authDomain: "network-one2one.firebaseapp.com",
  databaseURL: "https://network-one2one-default-rtdb.firebaseio.com",
  projectId: "network-one2one",
  storageBucket: "network-one2one.firebasestorage.app",
  messagingSenderId: "459177183744",
  appId: "1:459177183744:web:0bc8a4ee2ecb2b07eba6e5",
  measurementId: "G-08SGMJ2KC0"
};


// const firebaseConfig = {

//   apiKey: "AIzaSyDChKu3IzWs8MpduRJ1Fg8flSHi-KJCuP0",

//   authDomain: "network-one2one.firebaseapp.com",

//   databaseURL: "https://network-one2one-default-rtdb.firebaseio.com",

//   projectId: "network-one2one",

//   storageBucket: "network-one2one.firebasestorage.app",

//   messagingSenderId: "459177183744",

//   appId: "1:459177183744:web:0bc8a4ee2ecb2b07eba6e5",

//   measurementId: "G-08SGMJ2KC0"

// };


// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);
const messaging = getMessaging(app);
export { db,messaging, getToken, onMessage };

